import { useCallback } from "react";

import useClient from "hooks/useClient";

const useGetUser = (): {
  getUser: () => Promise<User>;
} => {
  const { client } = useClient();

  const getUser = useCallback(async () => {
    const { data } = await client({
      method: "get",
      url: "/user",
    });
    return data as User;
  }, [client]);

  return { getUser };
};

export default useGetUser;
